module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/pc/search_result_page/skill-f8901ff4045eb44dee52ec97cff72960.png";